import './styles/main.scss';
import Footer from './components/Footer';
import Header from './components/Header';
import AppRoutes from './Routes';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (

    <Router>
    <div className="app">
      <Header />
      <main>
       <AppRoutes />
      </main>
      <Footer />
    </div>
  </Router>
  );
}

export default App;
